import { AxiosResponse } from 'axios'
import { ServiceDependencies } from 'lib/core/services/magento'
import { axiosClient } from 'lib/core/services/magento/client'
import { EnumType, jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'
import { getProductQuery } from 'lib/core/services/magento/queries/productQuery'
import { MagentoVisitureProductsPayload, VisitureProductsQueryParams } from 'lib/types'

export interface VisitureProductsQueryObject {
  visitureProducts: {
    __args: {
      pageSize: number
      currentPage: number
      [key: string]: any
    }
    total_count: boolean
    page_info: {
      page_size: boolean
      current_page: boolean
      [key: string]: any
    }
    filters: {
      name: boolean
      filter_items_count: boolean
      request_var: boolean
      filter_items: {
        label: boolean
        value_string: boolean
        items_count: boolean
        [key: string]: any
      }
      [key: string]: any
    }
    sort_fields: {
      default: boolean
      options: {
        label: boolean
        value: boolean
        [key: string]: any
      }
      [key: string]: any
    }
    [key: string]: any
  }
}

export const visitureProductsQueryObject: VisitureProductsQueryObject = {
  visitureProducts: {
    __args: {
      pageSize: 0,
      filter: {},
      currentPage: 0
    },
    ...getProductQuery('items', {
      withBase: true,
      withCustomAttributes: true,
      withReviewSummary: true,
      withOnConfigurable: true
    }, true),
    total_count: true,
    page_info: {
      page_size: true,
      current_page: true
    },
    filters: {
      name: true,
      filter_items_count: true,
      request_var: true,
      filter_items: {
        label: true,
        value_string: true,
        items_count: true
      }
    },
    sort_fields: {
      default: true,
      options: {
        label: true,
        value: true
      }
    }
  }
}

export type GetVisitureProductsQuery = (input: VisitureProductsQueryParams) => Promise<AxiosResponse<{ data?: MagentoVisitureProductsPayload }>>

export const createVisitureProductsQuery = ({ getQueries }: ServiceDependencies): GetVisitureProductsQuery => async ({
  search,
  currentPage,
  filter,
  pageSize,
  sort
}) => {
  const query = getQueries().visitureProductsQuery

  query.visitureProducts.__args.filter = filter

  if (search) {
    query.visitureProducts.__args.search = search
  }

  query.visitureProducts.__args.pageSize = pageSize
  query.visitureProducts.__args.currentPage = currentPage

  if (sort) {
    query.visitureProducts.__args.sort = Object.keys(sort).reduce((obj: Record<string, EnumType>, key) => {
      obj[key] = new EnumType(sort[key])
      return obj
    }, {})
  }

  return axiosClient(jsonToGraphQLQuery(query), true)
}
